import IconUser from "/svg/user.svg";
import IconTasks from "/svg/list-check.svg";
import IconMatch from "/svg/cards.svg";
import IconCommunity from "/svg/starRating.svg";

export const navLinks = [
  { isMainButton: false, path: "/match", icon: IconMatch },
  { isMainButton: false, path: "/community", icon: IconCommunity },
  { isMainButton: true, path: "", icon: "" },
  { isMainButton: false, path: "/tasks", icon: IconTasks },
  { isMainButton: false, path: "/profile", icon: IconUser },
];
